@if (user.id === asset.author.id) {
    <div>
        <form [formGroup]="form">
            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" />
                </mat-form-field>
            </div>
            <div>
                <frog-markdown-textarea formControlName="description"></frog-markdown-textarea>
            </div>
            @if (dirty$ | async) {
                <div class="right">
                    <!-- this is just for the async sub -->
                </div>
            }
        </form>
    </div>
} @else {
    <h1 class="truncate" title="{{ asset.name }}">
        {{ asset.name }}
    </h1>
    <div class="description">
        <p [innerHTML]="asset.description | marked"></p>
    </div>
}

<small>{{ asset.created | date: "long" }}</small>

<ul class="list-inline">
    <li>
        <mat-icon>thumb_up</mat-icon>
        {{ asset.like_count }} Likes
    </li>
    <li>
        <mat-icon>comment</mat-icon>
        {{ asset.comment_count }} Comments
    </li>
    <li>
        <mat-icon>visibility</mat-icon>
        {{ asset.view_count }} Views
    </li>
</ul>
